var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useReducer } from 'react';
import { flowReducer, hydrateFormData, emptyFlowState } from '../hooks/df';
export var FlowContext = createContext(emptyFlowState);
export var FlowDispatchContext = createContext(null);
import { useState } from 'react';
import { refinanceTypes } from '../services/interfaces';
import { getFlowConfig, getUserGeoInfo, getFieldConfig } from '../services/dfUtils';
import { readDfStorage, updateSessionFromUrlParams, saveToDfStorage } from '../services/helperLib';
export function FlowProvider(_a) {
    var _this = this;
    var apiUrl = _a.apiUrl, children = _a.children;
    var _b = useReducer(flowReducer, emptyFlowState), flow = _b[0], dispatch = _b[1];
    var flowConfig;
    var _c = useState(false), isLoanType = _c[0], setIsLoanType = _c[1];
    useEffect(function () {
        var onPageShow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
        window.addEventListener("pageshow", onPageShow);
        updateSessionFromUrlParams();
        var flowId = readDfStorage("loanPurpose");
        var loanType = sessionStorage.getItem("loantype");
        if (flowId != loanType || flowId == null) {
            setIsLoanType(true);
        }
        var storageFlowState = readDfStorage("df_".concat(apiUrl));
        if (storageFlowState) {
            flowConfig = storageFlowState;
            var flowId_1 = storageFlowState.flowId, config = storageFlowState.config, currentStep = storageFlowState.currentStep, currentStepIndex = storageFlowState.currentStepIndex, isFirstStep = storageFlowState.isFirstStep, isLastStep = storageFlowState.isLastStep, formData = storageFlowState.formData;
            dispatch({
                type: "Initialize",
                flowId: flowId_1,
                config: config,
                currentStep: currentStep,
                currentStepIndex: currentStepIndex,
                isFirstStep: isFirstStep,
                isLastStep: isLastStep,
                formData: formData,
            });
        }
        else {
            var fetchFlow = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getFlowConfig(apiUrl)];
                        case 1:
                            flowConfig = _a.sent();
                            dispatch({
                                type: "Initialize",
                                flowId: apiUrl,
                                config: flowConfig,
                                currentStep: flowConfig.pages[0],
                                currentStepIndex: 0,
                                isFirstStep: true,
                                isLastStep: false,
                                formData: hydrateFormData(), //{}
                                isLoading: false,
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchFlow();
            getUserGeoInfo();
        }
        return function () {
            window.removeEventListener("pageshow", onPageShow);
        };
    }, []);
    useEffect(function () {
        if (isLoanType) { //Update loantype from url iff new session
            updateLoanTypefromUrlParam();
        }
    }, [isLoanType, flow]);
    var updateLoanTypefromUrlParam = function () {
        var _a;
        // Check if Url has fid,loantype and dispatch update
        var sessionFlowState = readDfStorage("df_".concat(apiUrl));
        if (!sessionFlowState)
            return;
        var fieldConfig = getFieldConfig("loanPurpose");
        var fId = sessionStorage.getItem("fid");
        var loanType = sessionStorage.getItem("loantype");
        var findOptionById = function (id) { var _a; return (_a = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.answerOptions) === null || _a === void 0 ? void 0 : _a.find(function (entry) { return entry.id === id; }); };
        var findOptionByValue = function (value) { var _a; return (_a = fieldConfig === null || fieldConfig === void 0 ? void 0 : fieldConfig.answerOptions) === null || _a === void 0 ? void 0 : _a.find(function (entry) { return entry.value === (value === null || value === void 0 ? void 0 : value.toLowerCase()); }); };
        var determineLoanPurpose = function (option) {
            if (option) {
                return refinanceTypes.includes(option.value) ? option.value : "purchase";
            }
            return "";
        };
        var loanPurpose = "";
        if (fId) {
            var flowId = parseInt(fId);
            var optionById = findOptionById(flowId);
            if (optionById) {
                loanPurpose = optionById.value;
            }
            else if (loanType) {
                var option = findOptionByValue(loanType);
                loanPurpose = determineLoanPurpose(option);
            }
        }
        else if (loanType) {
            var option = findOptionByValue(loanType);
            loanPurpose = determineLoanPurpose(option);
        }
        if (loanPurpose) {
            saveToDfStorage("loanPurpose", loanPurpose);
            dispatch({ type: "ResetFormData" });
            dispatch({
                type: "UpdateFormDataWithCurrentIndex",
                formData: (_a = {},
                    _a["loanPurpose"] = {
                        config: fieldConfig,
                        fieldValue: loanPurpose,
                        isValid: true,
                    },
                    _a),
            });
        }
        setIsLoanType(false);
    };
    // Initialize New Relic logging when flow is ready (similar to .NET FormEventsInitialization)
    useEffect(function () {
        if (flow.config && flow.flowId && !flow.isLoading) {
            console.log('[NEW_RELIC_INIT] Initializing New Relic for Dynamic Form:', {
                flowId: flow.flowId,
                templateType: flow.config.templateType,
                currentStep: flow.currentStep
            });
        }
    }, [flow.config, flow.flowId, flow.isLoading]);
    return (_jsx(FlowContext.Provider, { value: flow, children: _jsx(FlowDispatchContext.Provider, { value: dispatch, children: children }) }));
}
